import { Component, ViewChild, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { HttpService } from '../../services/http.service';
import { forEach } from '@angular/router/src/utils/collection';
import { UrlParams } from '../../helpers/url-params';
import { DateTime } from '@syncfusion/ej2-charts';
import { objBodyMail } from '../../models/Request/mail.model';
import { ToolbarService, LinkService,  HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
    selector: 'request-mail-dialog',
    templateUrl: './request-mail-dialog.html',
    providers: [ToolbarService, LinkService, HtmlEditorService]
})
export class RequestMailDialogComponent {
    @ViewChild('dlg') dlg: DialogComponent;
    @ViewChild('mailContentRTE') mailContentRTE: any;
    descriptMail: string = null;
    isSendMail: boolean = false;
    visible: boolean = false;
    allPrincipal: boolean = true;
    callback: any = null;
    selPrincipals: string[] = [];
    principals: any[] = [];
    tenderId: number = 0;
    requestCode: string = null;
    status: string = null;
    viewPrincipals: boolean = false;
    customerName: string = null;
    customerCode: string = null;
    packageName: string = null;
    closingDate: Date = null;
    tenderStatus: string = null;
    selAttachPrincipals: string[] = [];
    detail: string = null;
    tenderName: string = null;
    deadLine: Date = null;
    effFrom: Date = null;
    effTo: Date = null;    
    contractEffFrom: Date = null;
    contractEffTo: Date = null;
    otherContent: string = null;

    toolsContent: any = {        
        enableFloating: false,
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', //'FontColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            '|', 'FullScreen']
    };
    
    objMail: objBodyMail = new objBodyMail();

    constructor(private cdr: ChangeDetectorRef,private http: HttpService) {
    }

    show(callback) {
        this.callback = callback;
        this.reset();
        this.getPrincipals();
        if (this.tenderStatus == 'Open') {
            this.allPrincipal = true;
            //this.viewPrincipals = true;
            this.descriptMail = 'Product list_' + this.requestCode + '_' + this.customerName + ' (' + this.customerCode + ')';
        } else if (this.tenderStatus == 'Waiting for principal approve') {
            this.allPrincipal = true;
            //this.viewPrincipals = true;            
            this.descriptMail = 'Recommend_' + this.requestCode + '_' + this.customerName;
        } else if (this.tenderStatus == 'Win' || this.tenderStatus == 'Lost') {                        
            this.allPrincipal = true;
            //this.viewPrincipals = true;
            this.descriptMail = 'Update result of_' + this.requestCode + '_' + this.customerName + '_' + this.detail;
        } else {
            return;
        }
        this.cdr.detectChanges();
    }

    reset() {
        //this.revise = null;
        this.descriptMail = null;
        this.viewPrincipals = false;
        this.principals = [];
        this.selPrincipals = [];
        this.allPrincipal = true;
        this.selAttachPrincipals = [];
        /*this.requestCode = null;
        this.status = null;        
        this.customerName = null;
        this.customerCode = null;
        this.packageName = null;
        this.closingDate = null;
        this.tenderStatus = null;        
        this.detail = null;
        this.tenderName = null;
        this.deadLine = null;
        this.efffrom = null;
        this.effto = null;        
        this.contractEffFrom = null;
        this.contractEffTo = null;*/
        this.objMail = new objBodyMail();
    }

    onOK() {
        
        //this.callback({ 'Revise': this.revise, 'LetterNo': this.letterNo });
        this.isSendMail = true;                
        let paramObj =
        {
            TenderId: this.tenderId,
            RefNo: this.requestCode,
            Subject: this.descriptMail,
            CustomerName: this.customerName,
            CustomerCode: this.customerCode,
            PackageName: this.packageName,
            ClosingDate: this.closingDate,
            UrlAddr: window.location.href,
            SelPrincipals: this.selPrincipals,
            Principals: this.principals,
            SelAttachPrincipals: this.selAttachPrincipals,
            Detail: this.detail,
            TenderName: this.tenderName,
            DeadLine: this.deadLine,
            EffFrom: this.effFrom,
            EffTo: this.effTo,            
            ContractEffFrom: this.contractEffFrom,
            ContractEffTo: this.contractEffTo,
            Area: null,
            OtherContent: this.otherContent
        };
        this.objMail.set(paramObj);
        //console.log(this.deadLine);
        if (this.allPrincipal == true) {
            if (this.tenderStatus == 'Open') {  //Send product list mail when tender status is Open
                this.http.post(`api/Util/SendProcerementMailAllPrn/`, this.objMail, res => {
                    //this.dlg.hide();
                    //this.callback({ 'descriptMail': this.descriptMail, 'isSendMail': this.isSendMail });
                });
                this.dlg.hide();
            } else if (this.tenderStatus == 'Waiting for principal approve') {
                this.http.post(`api/Util/SendRecommendMailSelPrn/`, this.objMail, res => {
                    //this.dlg.hide();                    
                });
                this.dlg.hide();
            } else if (this.tenderStatus == 'Principal approved') {

            } else if (this.tenderStatus == 'Win' || this.tenderStatus == 'Lost') {
                this.http.post(`api/Util/SendFinalizationMailSelPrn/`, this.objMail, res => {
                    //this.dlg.hide();
                });
                this.dlg.hide();
            }
            
        } else {
            if (this.tenderStatus == 'Open') {  //Send product list mail when tender status is Open
                this.http.post(`api/Util/SendProcerementMailSelPrn`, this.objMail, res => {
                    //this.dlg.hide();                    
                });
                this.dlg.hide();
            } else if (this.tenderStatus == 'Waiting for principal approve') {
                this.http.post(`api/Util/SendRecommendMailSelPrn/`, this.objMail, res => {
                    //this.dlg.hide();                    
                });
                this.dlg.hide();
            } else if (this.tenderStatus == 'Principal approved') {                
            } else if (this.tenderStatus == 'Win' || this.tenderStatus == 'Lost') {
                this.http.post(`api/Util/SendFinalizationMailSelPrn/`, this.objMail, res => {
                    //this.dlg.hide();
                });
                this.dlg.hide();
            }            
        }
        
    }

    onCancel() {
        this.isSendMail = false;
        this.reset();
        this.dlg.hide();
        this.callback({ 'isSendMail': this.isSendMail });
    }

    getPrincipals() {
        this.http.get(`api/Util/GetPrincipalListForEmail/${this.requestCode}/${this.status}`, res => {
            this.principals = res.Result;
            for (let p of this.principals) {
                this.selPrincipals.push(p.Value);
                this.selAttachPrincipals.push(p.Value);
            }
            this.dlg.show();
            //console.log('Prn:' + this.principals);
        });
    }

    onCheckAllPrincipal() {
        this.allPrincipal = !this.allPrincipal;
        if (this.allPrincipal == false) {
            this.viewPrincipals = true;            
            //console.log('ViewTrue');
            //this.getPrincipals();
            this.selPrincipals = [];
            this.selAttachPrincipals = [];
        } else {
            this.viewPrincipals = false;            
            for (let p of this.principals) {
                this.selPrincipals.push(p.Value);
                this.selAttachPrincipals.push(p.Value);
            }
            //console.log(this.selPrincipals);
        }
    }

    onClickPrincipals(evt: any, id: any) {
        const index = this.selPrincipals.indexOf(id, 0);

        if (evt.checked) {
            if (index == -1)
                this.selPrincipals.push(id);
        }
        else if (index > -1) {
            this.selPrincipals.splice(index, 1);
        }

        //let selPrincipalStr = 'All';
        //if (this.selPrincipals.length > 0)
            //selPrincipalStr = this.selPrincipals.join(',');
        this.selAttachPrincipals = this.selPrincipals;
    }
}
